import MuiSwitch from "@mui/material/Switch";

import { ComponentProps } from "./switch.type";

const Switch = ({ defaultChecked, checked, handleChange }: ComponentProps) => {
  return <MuiSwitch checked={checked} onChange={handleChange} defaultChecked />;
};

export default Switch;
